<script lang="ts" setup>
const { t } = useI18n()
</script>

<template>
  <div class="relative">
    <div
      class="private-event flex flex-col justify-center items-center pt-10 pb-21.5 xl:flex-row xl:justify-between xl:items-start xl:max-w-251 xl:w-full xl:mx-auto xl:py-22"
    >
      <NuxtImg
        loading="lazy"
        :alt="t('your') + ' ' + t('private-event-engine')"
        class="w-71.25 h-69.5 xl:w-107.5 xl:h-105"
        src="/images/nft/image-4.webp"
      />

      <div class="mx-4.5 mt-5 xl:mt-22.5 xl:mx-0">
        <div
          class="text-2xl leading-[42px] tracking-wide text-white text-center xl:text-left sm:text-[28px]"
        >
          {{ t('your') }}
          <span class="text-[#ffc658]">{{ t('private-event-engine') }} </span>
        </div>
        <div
          class="max-w-115 mt-10.5 text-[18px] leading-[27px] tracking-wide text-[#CECECE] text-center xl:text-left"
        >
          {{ t('keep-your-community') }}
        </div>
      </div>
    </div>
    <div class="private-event-engine">
      <NuxtImg
        loading="lazy"
        :alt="t('your') + ' ' + t('private-event-engine')"
        class="w-full object-cover top-0 -z-1 h-full"
        src="/images/home/private-event-engine.webp"
      />
    </div>
  </div>
</template>

<style scoped>
.private-event-engine {
  @apply h-full w-full absolute bottom-0 -z-1;
  &:after {
    @apply absolute left-0 bottom-0 w-full z-1 h-full;
    content: '';
    background: linear-gradient(180deg, #151515 0%, rgba(21, 21, 21, 0) 100%);
  }
}
</style>
